import { createAdminDeveloper, deleteAdminDeveloper, updateAdminDeveloper } from "./api";
import { initialAdminDeveloper } from "./constants";
import { getApiErrorMessage } from "./formatters";

export function useDeveloperActions({
  adminDeveloperForm,
  authHeaders,
  fetchDashboard,
  isEditingDeveloper,
  setAdminDeveloperForm,
  setIsDeveloperEditorOpen,
  setLoading,
  toast,
}) {
  const handleCreateDeveloper = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const payload = {
        full_name: adminDeveloperForm.full_name,
        email: adminDeveloperForm.email,
        can_access_platform: adminDeveloperForm.can_access_platform,
        ...(adminDeveloperForm.password ? { password: adminDeveloperForm.password } : {}),
      };
      const response = isEditingDeveloper
        ? await updateAdminDeveloper(adminDeveloperForm.id, payload, authHeaders)
        : await createAdminDeveloper(payload, authHeaders);
      setAdminDeveloperForm(initialAdminDeveloper);
      setIsDeveloperEditorOpen(false);
      await fetchDashboard();
      toast({
        title: isEditingDeveloper ? "Développeur mis à jour" : "Accès développeur créé",
        description: response.data.can_access_platform
          ? "Le compte développeur peut accéder a la plateforme."
          : "Le compte développeur est créé sans accès plateforme.",
      });
    } catch (error) {
      toast({
        title: isEditingDeveloper ? "Mise à jour impossible" : "Création du développeur impossible",
        description: getApiErrorMessage(error, "Verifiez les informations saisies."),
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEditDeveloper = (developer) => {
    setAdminDeveloperForm({
      id: developer.id,
      full_name: developer.full_name,
      email: developer.email,
      password: "",
      can_access_platform: developer.can_access_platform,
    });
    setIsDeveloperEditorOpen(true);
  };

  const resetDeveloperForm = () => {
    setAdminDeveloperForm(initialAdminDeveloper);
    setIsDeveloperEditorOpen(false);
  };

  const openCreateDeveloperForm = () => {
    setAdminDeveloperForm(initialAdminDeveloper);
    setIsDeveloperEditorOpen(true);
  };

  const handleDeleteDeveloper = async () => {
    if (!adminDeveloperForm.id) return;

    setLoading(true);
    try {
      await deleteAdminDeveloper(adminDeveloperForm.id, authHeaders);
      resetDeveloperForm();
      await fetchDashboard();
      toast({
        title: "Developpeur bloque",
        description: "Son accès est coupé, mais l'historique reste conserve.",
      });
    } catch (error) {
      toast({
        title: "Blocage impossible",
        description: getApiErrorMessage(error, "Veuillez reessayer."),
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    handleCreateDeveloper,
    handleDeleteDeveloper,
    handleEditDeveloper,
    openCreateDeveloperForm,
    resetDeveloperForm,
  };
}
